import { component } from 'picoapp';
import Modal from 'utils/modal';

export default component((node) => {
  const modal = Modal(node, node);
  const accept: HTMLButtonElement = node.querySelector('[data-accept]');
  const declines = [...node.querySelectorAll<HTMLButtonElement>('[data-decline]')];

  document.addEventListener('terms:trigger', () => {
    modal.open();
  });

  accept.addEventListener('click', () => {
    modal.close();
    document.dispatchEvent(new CustomEvent('terms:accept'));
  });

  if (declines.length) {
    declines.forEach((decline) => {
      decline.addEventListener('click', () => {
        modal.close();
      });
    });
  }
});
